import React from 'react';
import { Banner } from './Banner';
import { MedelyDateTime } from '@medely/date-time-tools';

type JobDetailsAwaitReleaseBannerProps = {
  proDidSwapRequest?: boolean;
  proHasSwapRequestPendingFacility?: boolean;
  proAwaitingDropRequest?: boolean;
  proAwaitingReleaseRequest?: boolean;
  proAskedForReleaseButJobIsNotReassigned?: boolean;
  expirationInfo?: string | null;
  timezone?: string | null;
};

export const JobDetailsAwaitReleaseBanner = ({
  proDidSwapRequest,
  proHasSwapRequestPendingFacility,
  proAwaitingDropRequest,
  proAwaitingReleaseRequest,
  proAskedForReleaseButJobIsNotReassigned,
  expirationInfo,
  timezone,
}: JobDetailsAwaitReleaseBannerProps) => {
  const medelyDateTime = expirationInfo
    ? new MedelyDateTime(expirationInfo, { tz: timezone ?? 'system' })
    : null;

  const expirationDateAndTime = medelyDateTime
    ? `${medelyDateTime.dayOfWeekHighlight} at ${medelyDateTime.militaryTime}`
    : null;

  const expirationText = expirationDateAndTime ? ` Expires on ${expirationDateAndTime}.` : '';

  const getMessage = () => {
    if (proDidSwapRequest || proHasSwapRequestPendingFacility) {
      return 'Swap request pending approval';
    }
    if (proAwaitingDropRequest) {
      return 'Drop request pending approval';
    }
    if (proAwaitingReleaseRequest) {
      return `Release request pending approval.${expirationText}`;
    }
    if (proAskedForReleaseButJobIsNotReassigned) {
      return `Release accepted; final approval pending reassignment.${expirationText}`;
    }
  };

  return (
    <Banner
      bgColor="state.warning.backing-1"
      iconColor="state.warning.secondary"
      title={getMessage()}
    />
  );
};
